import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas,
  PostNoParas,
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { PagingBody } from "../Model/PagingBody";
import { GetSingleSysItem } from "../Logic/SysItemLogic";
import { GetCurrentUserInfo } from "../Logic/HomeLogic";
import { GetFrameById, GetSingeleUser } from "../Logic/StructureLogic";
import { Reflect } from "core-js";

InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);
//获取流程表单
async function GetWorkFlowInput(flowid) {
  var paras = { flowid: flowid };
  return await GetByParas("ED09F7DF-A984-4238-8DE3-A40C422CC854", paras);
}
//获取注意事项
async function GetAttentions(flowid) {
  var paras = { flowid: flowid };
  return await GetByParas("EF1BB906-2333-4A3E-97B7-A1D7DCD6A8D5", paras);
}
//获取按钮及字段状态
async function GetFieldStatusAndButtons(flowid, stepid) {
  var paras = { flowid: flowid, stepid: stepid };
  return await GetByParas("A0C67C00-0285-40DD-900F-52382EFBC0D7", paras);
}
//获取流程第一步骤ID
async function GetFirstStepId(flowid) {
  var paras = { flowid: flowid };
  return await GetByParas("5f452464-b261-4b2e-af21-39ceadf30970", paras);
}
//获取发送时的下面步骤集合
async function GetFlowSendNextSteps(userid, flowid, stepid, instanceid) {
  var paras = {
    userid: userid,
    flowid: flowid,
    stepid: stepid,
    instanceid: instanceid,
  };

  return await GetByParas("6704feb2-2301-4f60-ab98-4ffb0e3215f0", paras);
}
//获取步骤时间线
async function GetStepTimeLine(userid, flowid, stepid, instanceid) {
  var paras = {
    userid: userid,
    flowId: flowid,
    stepId: stepid,
    instanceId: instanceid,
  };
  return await GetByParas("2aa9da6e-aaec-4987-bcc9-fb0120aa1659", paras);
}
//获取待我审批的列表
async function GetWaitTasks(userid, searchText, flowid, pageIndex, pageSize) {
  var data = {
    userid: userid,
    searchText: searchText,
    flowId: flowid,
    pageIndex: pageIndex,
    pageSize: pageSize,
  };
  return Post("91068514-d453-4b26-831f-95116ea6ece4", data);
}
//获取我发起的的列表
async function GetUserCreateTasks(
  userid,
  searchText,
  flowid,
  pageIndex,
  pageSize
) {
  var data = {
    userid: userid,
    pageIndex: pageIndex,
    pageSize: pageSize,
    searchText: searchText,
    flowId: flowid,
  };
  return Post("419afa4f-e608-4aba-80a4-28df737dde3a", data);
}
//获取我处理的列表
async function GetUserDealTasks(
  userid,
  searchText,
  flowid,
  pageIndex,
  pageSize
) {
  var data = {
    userid: userid,
    pageIndex: pageIndex,
    pageSize: pageSize,
    searchText: searchText,
    flowId: flowid,
  };
  return Post("61901957-1efc-4afc-9d38-51c763909083", data);
}
//获取抄送我的列表
async function GetCCUserTasks(userid, searchText, flowid, pageIndex, pageSize) {
  var data = {
    userid: userid,
    pageIndex: pageIndex,
    pageSize: pageSize,
    searchText: searchText,
    flowId: flowid,
  };
  return Post("23ef9e4d-ab6d-495d-a0c2-906ed268c1bc", data);
}
//获取所有流程
async function GetAllWorkFlow() {
  var paras = {};
  return GetByParas("84a954a6-4c0a-4342-b4f0-5bb604c8d27a", paras);
}
//执行流程
async function ExecuteFlow(execute) {
  return Post("57871b3f-7b02-4179-9b3e-c40d44ff7eeb", execute);
}
async function GetWorkFlowData(flowid, instanceid) {
  var paras = {
    flowId: flowid,
    instanceId: instanceid,
  };
  return await GetByParas("4b0eea3d-211b-463e-8f0e-0b764a4a1a4b", paras);
}
async function GetFirstSenderId(instanceid) {
  var paras = {
    instanceid: instanceid,
  };
  return await GetByParas("62638a2f-75e1-46a3-98d3-997664a37b83", paras);
}
async function GetFlowCanelable(flowId) {
  var paras = {
    flowId: flowId,
  };
  return await GetByParas("69c11fbf-1b3b-4aba-9309-5574bad77990", paras);
}
async function Cancel(taskid, flowid, instanceid, stepid) {
  var paras = {
    taskid: taskid,
    flowid: flowid,
    instanceid: instanceid,
    stepid,
    stepid,
  };
  return await GetByParas("fab77c72-fd00-4796-bc07-3a433b538aea", paras);
}
async function Refuse(execute) {
  return await Post("cdaf302f-fd00-4d90-88e8-650d5310b411", execute);
}
async function Completed(execute) {
  return await Post("d095f0ae-44ff-4176-887a-3ab543400166", execute);
}
async function HandOver(userName, ReceiveName, taskid, userid, reason) {
  var data = {
    userName: userName,
    ReceiveName: ReceiveName,
    taskid: taskid,
    userid: userid,
    reason: ''
  };
  if (reason) {
    data.reason = reason;
  }
  return await Post("550c7247-5e6d-41d0-b10d-047975087739", data);
}
async function getInputData(input, data) {
  var value = data;
  if (
    input.InputType == "select" ||
    input.InputType == "checkbox" ||
    input.InputType == "radio" ||
    input.InputType == "cascade"
  ) {
    if (input.DictionaryType == 2) {
      var item = await GetSingleSysItem(data);
      value = item ? item.ClassName : "";
      return value;
    }
    else if (input.DictionaryType == 3) {
      var frames = await GetFrameById(data);
      value = frames.length > 0 ? frames[0].ClassName : "";
      return value;
    }
    else {
      return value;
    }
  } else if (input.InputType == "attach") {
    if (data) {
      var arr = data.split(",");
      value = arr;
      return value;
    }
  } else if (input.InputType == "selectmember") {
    if (data) {
      var arr = data.split(",");
      var values = [];
      for (let v of arr) {
        var res = await GetSingeleUser(v);
        if (res) {
          values.push(res.TrueName);
        }
      }
      return values.join(",");
    }
  } else if (input.InputType == "selectframe") {
    if (data) {
      var arr = data.split(",");
      var values = [];
      for (let v of arr) {
        var res = await GetFrameById(v);
        if (res) {
          values.push(res[0].ClassName);
        }
      }
      value = values.join(",");
      return value;
    }
  } else if (input.IsEncrypt == "1") {
    var user = GetCurrentUserInfo();
    if (input.EncryptType == "0") {
      // var firstSenderId = await GetFirstSenderId(t.InstanceID);
      // if (firstSenderId != user.UserId) {
      //   value = "****加密字段****";
      // }
      return value;
    } else if (input.EncryptType == "1") {
      if (input.EncryptValue.indexOf(user.UserId) < 0) {
        value = "****加密字段****";
      }
      return value;
    }
  } else {
    return value;
  }
}
async function setDetailData(input, data) {
  var detailData = eval(data);
  var detailInput = eval(input.DetailValue);
  //console.log(detailData,'setDetailData');
  if (detailData) {
    var ddata = [];
    if (detailData[0] instanceof Array) {
      //console.log("Array");
      ddata = detailData;
      ddata.forEach(async (ld) => {
        ld.forEach(async (dd) => {
          var d = detailInput.filter((p) => p.Field == dd.field);
          //console.log(d);
          if (d.length > 0) {
            dd.InputType = d[0].InputType;
            dd.Value = await getInputData(d[0], dd.value);
          }
        });
      });
    } else {
      //console.log("Object");
      detailData.forEach((element) => {
        var d = [];
        var keys = Reflect.ownKeys(element);
        keys.forEach((fd) => {
          var di = detailInput.filter((p) => p.Field == fd);
          if (di.length > 0) {
            d.push({
              field: fd,
              value: Reflect.get(element, fd),
              name: di[0].Name,
              InputType: di[0].InputType,
            });
          }
        });
        ddata.push(d);
      });
    }
    //console.log(ddata,"ddata");
    return ddata;
  } else {
    return data;
  }
}
//获取我提交的审批是否重复
async function GetUserWorkFlow(userid, flowid) {
  var paras = {
    userid: userid,
    flowId: flowid
  };
  return await GetByParas("E5232983-963F-43A3-8654-51901EE5111C", paras);
}
export {
  GetWorkFlowInput,
  GetAttentions,
  GetFieldStatusAndButtons,
  GetFirstStepId,
  GetFlowSendNextSteps,
  GetStepTimeLine,
  GetWaitTasks,
  GetUserCreateTasks,
  GetCCUserTasks,
  GetUserDealTasks,
  GetAllWorkFlow,
  ExecuteFlow,
  GetWorkFlowData,
  GetFirstSenderId,
  GetFlowCanelable,
  getInputData,
  setDetailData,
  Cancel,
  Refuse,
  Completed,
  HandOver,
  GetUserWorkFlow,
};
